module.exports = __webpack_public_path__ + "static/media/arrow_active.3cb0ca16.svg";